import { useConfig } from "~/core/configuration/configContext";

export interface UseShowResultsResult {
    showFulltextResults: boolean;
    showCategoryResults: boolean;
    showProductResults: boolean;
}

export const useShowResults = (): UseShowResultsResult => {
    const config = useConfig();

    const instantSearchConfig = config.layout.configuration.instantSearch;

    const showFulltextResults = instantSearchConfig?.layout?.showFulltextResults ?? false;
    const showCategoryResults = instantSearchConfig?.layout?.showCategoryResults ?? false;
    const showProductResults = instantSearchConfig?.layout?.showProductResults ?? false;

    return {
        showFulltextResults,
        showCategoryResults,
        showProductResults
    }
}
